import {VersionVariants} from '@jobseeker/lotus/enums';
import NotImplemented from '@jobseeker/lotus/elements/NotImplemented';

import V2 from './V2';

import type {JobOverviewCardProps} from './type';

const componentMap: any = {};
componentMap[VersionVariants.VERSION_ONE] = NotImplemented;
componentMap[VersionVariants.VERSION_TWO] = V2;
componentMap[VersionVariants.VERSION_THREE] = NotImplemented;

const JobOverviewCard = (props: JobOverviewCardProps) => {
  let Component;
  if (Object.keys(componentMap).includes(props.variant)) {
    Component = componentMap[props.variant];
  } else {
    Component = componentMap[VersionVariants.VERSION_ONE];
  }
  return <Component {...props} />;
};

export default JobOverviewCard;

export {default as EvaluationGate} from './EvaluationGate';
export {accessEvaluationInApp} from './appLink';
